import Vue from 'vue';
import store from './store';
import Paginate from 'vuejs-paginate';
import VMask from 'v-mask';
import VueNotification from 'vue-notification';
import axios from '@sone/sone-frontend-core/src/plugins/axios';
import '@sone/sone-frontend-core/src/plugins/registerComponentHooks';
import Loading from '@sone/sone-frontend-core/src/plugins/loading';
import App from './App.vue';
import router from './router';
import '@sone/sone-frontend-components/dist/sone-frontend-components.css';
import './plugins/material';
import './assets/index.scss';
import Oidc from '@sone/sone-frontend-core/src/plugins/oidc';
import oidcSettings from '@/config/oidc';
import userMiddleware from './middlewares/user';
import oidcMiddleware from './middlewares/oidc';
import { S1vm } from './s1vm';
import { IndexComponent } from './components';
import i18nMiddleware from '@/middlewares/i18n';
import i18n from './plugins/i18n';

Vue.use(Loading, { store, router, timeout: 0 });
i18nMiddleware(router, store);

S1vm.register();
IndexComponent.register();

Vue.use(Oidc, {
  router,
  oidcSettings,
  store,
  middleware: oidcMiddleware,
});
Vue.use(axios);
userMiddleware(router, store);
Vue.prototype.$baseUrl = process.env.BASE_URL;
Vue.config.productionTip = false;
Vue.component('paginate', Paginate);
Vue.use(VMask);
Vue.use(VueNotification);
store.commit('user/SET_PROFILE_URL', process.env.BASE_URL);
store.commit('user/SET_LOGOUT_URL', `${process.env.BASE_URL}logout`);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
